var SearchApp = window.SearchApp || {};

SearchApp.DecodeService = function(url) {
	// Public Methods
	this.decode = decode;

	// Private methods;
	function decode(data, callback) {
		if (data.xid) {
			callback(data.xid);
			return;
		}

		var request = {key: data.key};
		$.get(url, request)
			.then(function(response) {
				var xid = response.Xid || response.xid;
				callback(xid);
			});
	}
};
